//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";

export default {
	name: "PaymentForm",
	components: {
	},
	data: function () {
		return {
			invalidMessage: '',
			options: {
				months: [],
				states: [],
				years: [],
			},
			selected: {
				address: '',
				address2: '',
				ccNumber: '',
				ccv: '',
				city: '',
				email: '',
				firstName: '',
				lastName: '',
				mm: '',
				state: '',
				yyyy: '',
				zipCode: '',
			},
			valid: {
				address: true,
				ccNumber: true,
				ccv: true,
				city: true,
				email: true,
				firstName: true,
				lastName: true,
				mm: true,
				state: true,
				yyyy: true,
				zipCode: true,
			},
		};
	},
	computed: {
		...mapGetters(["config", "loading", "invoices", "processingPayment", "paymentDetails"]),
		totalDue() {
			let val = 0;
			this.invoices.forEach((el) => {
				val += el.balance;
			})
			let dollarAmount = val.toFixed(2)

			return `$${dollarAmount}`;
		},
	},
	watch: {
		async paymentDetails() {
			if (this.paymentDetails && this.paymentDetails.isSuccessful) {
				await this.invoices.forEach((invoice) => {
					let obj = {
						paymentReceivedDate: new Date().toISOString(),
						creditCardHolderName: `${this.selected.firstName} ${this.selected.lastName}`,
						creditCardNumber: this.paymentDetails.authorizeNetResponse.transactionResponse.accountNumber,
						creditCardType: this.paymentDetails.authorizeNetResponse.transactionResponse.accountType,
						transactionID: this.paymentDetails.authorizeNetResponse.transactionResponse.transId,
						invoice: invoice.invoiceNumber,
						jobNumber: invoice.orderNumber,
						database: invoice.invoiceFoundAt,
						invoicePaid: invoice.balance,
						email: this.selected.email
					}
					this.savePaymentData({payload: `${this.$root.webq}/api/payment/savepaymentdata`, data: obj });
				})

				this.selected = {
					address: '',
					address2: '',
					ccNumber: '',
					ccv: '',
					city: '',
					email: '',
					firstName: '',
					lastName: '',
					mm: '',
					state: '',
					yyyy: '',
					zipCode: '',
				};
			}
		}
	},
	methods: {
		...mapActions(["payInvoice", "savePaymentData"]),
		focusEvent(el) {
			this.valid[el.field] = true;
			this.invalidMessage = '';
		},
		goBack() {
			if (this.paymentDetails && this.paymentDetails.isSuccessful) {
				this.$emit('reset');
			} else {
				this.$emit('goBack');
			}
		},
		payNow() {
			let valid = this.validate();
			if (valid) {
				let obj = {
					invoices: this.invoices,
					creditCardInfo: this.selected
				}

				this.payInvoice({payload: `${this.$root.api}/Payment/PayInvoice`, data: obj });
			}
		},
		validate() {
			let valid = true;
			this.config.inputs.forEach((el) => {
				if (el.required) {
					if (el.validation === 'email') {
						let emailRegEx = /\S+@\S+\.\S+/;
						let validEmail = emailRegEx.test(this.selected[el.field]);
						if (!validEmail) {
							this.valid[el.field] = false;
							valid = false;
						}
					} else if (this.selected[el.field].length === 0 || (el.min && this.selected[el.field].length < el.min) || (el.max && this.selected[el.field].length > el.max)) {
						this.valid[el.field] = false;
						valid = false;
					}
				}
			})

			if (valid) {
				let currMonth = new Date().getMonth() + 1;
				let currYear = new Date().getFullYear();
				let fieldMM = parseInt(this.selected.mm);
				let fieldYYYY = parseInt(this.selected.yyyy);

				if (fieldYYYY === currYear && fieldMM < currMonth) {
					this.invalidMessage = 'Invalid Expiration Date';
					valid = false;
				}
			}

			return valid;
		},
	},
	mounted() {
		this.options.months = this.config.options.months;
		this.options.states = this.config.options.states;

		let currentYear = new Date().getFullYear();
		this.options.years.push({ text: currentYear, value: currentYear.toString() });
		for (let i = 1; i < 10; i++) {
			this.options.years.push({ text: currentYear + i, value: (currentYear + i).toString() });
		}
	}
};
